document.addEventListener("DOMContentLoaded", function () {
  // Tab Navigation Slider Functionality
  const initTabSlider = () => {
    const tabContainer = document.querySelector(
      ".rbt-course-area .online-academy-tab-filter"
    );
    const scrollContainer = document.querySelector(
      ".rbt-course-area .tab-scroll-container"
    );
    if (!tabContainer || !scrollContainer) return;

    // Check if already initialized
    if (tabContainer.dataset.sliderInitialized === "true") return;
    tabContainer.dataset.sliderInitialized = "true";

    // Create navigation arrows
    const createNavigationArrows = () => {
      // Remove existing arrows if any
      const existingArrows = scrollContainer.querySelectorAll(".tab-nav-arrow");
      existingArrows.forEach((arrow) => arrow.remove());

      // Create left arrow
      const leftArrow = document.createElement("button");
      leftArrow.className = "tab-nav-arrow tab-nav-arrow-left";
      leftArrow.innerHTML = '<i class="feather-arrow-left"></i>';
      leftArrow.setAttribute("aria-label", "Previous tabs");
      leftArrow.setAttribute("type", "button");

      // Create right arrow
      const rightArrow = document.createElement("button");
      rightArrow.className = "tab-nav-arrow tab-nav-arrow-right";
      rightArrow.innerHTML = '<i class="feather-arrow-right"></i>';
      rightArrow.setAttribute("aria-label", "Next tabs");
      rightArrow.setAttribute("type", "button");

      // Add arrows to container
      scrollContainer.appendChild(leftArrow);
      scrollContainer.appendChild(rightArrow);

      // Arrow click handlers
      leftArrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const scrollAmount = tabContainer.clientWidth * 0.8;
        tabContainer.scrollBy({
          left: -scrollAmount,
          behavior: "smooth"
        });
      });

      rightArrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const scrollAmount = tabContainer.clientWidth * 0.8;
        tabContainer.scrollBy({
          left: scrollAmount,
          behavior: "smooth"
        });
      });

      return { leftArrow, rightArrow };
    };

    const { leftArrow, rightArrow } = createNavigationArrows();

    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse events for drag scrolling
    const handleMouseDown = (e) => {
      // Don't start drag if clicking on arrow buttons or tab buttons
      if (
        e.target.closest(".tab-nav-arrow") ||
        e.target.closest('button[data-bs-toggle="tab"]')
      )
        return;

      isDown = true;
      tabContainer.style.cursor = "grabbing";
      startX = e.pageX - tabContainer.offsetLeft;
      scrollLeft = tabContainer.scrollLeft;
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - tabContainer.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      tabContainer.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
      isDown = false;
      tabContainer.style.cursor = "grab";
    };

    tabContainer.addEventListener("mousedown", handleMouseDown);
    tabContainer.addEventListener("mouseleave", handleMouseUp);
    tabContainer.addEventListener("mouseup", handleMouseUp);
    tabContainer.addEventListener("mousemove", handleMouseMove);

    // Touch events for mobile devices
    const handleTouchStart = (e) => {
      // Don't start drag if touching arrow buttons or tab buttons
      if (
        e.target.closest(".tab-nav-arrow") ||
        e.target.closest('button[data-bs-toggle="tab"]')
      )
        return;

      isDown = true;
      startX = e.touches[0].pageX - tabContainer.offsetLeft;
      scrollLeft = tabContainer.scrollLeft;
    };

    const handleTouchMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.touches[0].pageX - tabContainer.offsetLeft;
      const walk = (x - startX) * 2;
      tabContainer.scrollLeft = scrollLeft - walk;
    };

    const handleTouchEnd = () => {
      isDown = false;
    };

    tabContainer.addEventListener("touchstart", handleTouchStart, {
      passive: false
    });
    tabContainer.addEventListener("touchend", handleTouchEnd);
    tabContainer.addEventListener("touchmove", handleTouchMove, {
      passive: false
    });

    // Update scroll indicators and arrow visibility
    const updateScrollIndicators = () => {
      const isAtStart = tabContainer.scrollLeft <= 0;
      const isAtEnd =
        tabContainer.scrollLeft >=
        tabContainer.scrollWidth - tabContainer.clientWidth - 1;

      // Update container classes
      scrollContainer.classList.toggle("scroll-start", isAtStart);
      scrollContainer.classList.toggle("scroll-end", isAtEnd);

      // Update arrow visibility
      if (leftArrow && rightArrow) {
        leftArrow.style.opacity = isAtStart ? "0.3" : "1";
        leftArrow.style.pointerEvents = isAtStart ? "none" : "auto";

        rightArrow.style.opacity = isAtEnd ? "0.3" : "1";
        rightArrow.style.pointerEvents = isAtEnd ? "none" : "auto";
      }
    };

    // Initial check
    updateScrollIndicators();

    // Update on scroll with throttling
    let scrollTimeout;
    tabContainer.addEventListener("scroll", () => {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateScrollIndicators, 10);
    });

    // Update on window resize with debouncing
    let resizeTimeout;
    window.addEventListener("resize", () => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateScrollIndicators, 100);
    });

    // Keyboard navigation
    const handleKeydown = (e) => {
      const activeTab = tabContainer.querySelector(
        'button[aria-selected="true"]'
      );
      if (!activeTab) return;

      const tabs = Array.from(
        tabContainer.querySelectorAll('button[data-bs-toggle="tab"]')
      );
      const currentIndex = tabs.indexOf(activeTab);

      switch (e.key) {
        case "ArrowLeft":
          e.preventDefault();
          if (currentIndex > 0) {
            tabs[currentIndex - 1].click();
          }
          break;
        case "ArrowRight":
          e.preventDefault();
          if (currentIndex < tabs.length - 1) {
            tabs[currentIndex + 1].click();
          }
          break;
      }
    };

    tabContainer.addEventListener("keydown", handleKeydown);

    // Cleanup function
    const cleanup = () => {
      tabContainer.removeEventListener("mousedown", handleMouseDown);
      tabContainer.removeEventListener("mouseleave", handleMouseUp);
      tabContainer.removeEventListener("mouseup", handleMouseUp);
      tabContainer.removeEventListener("mousemove", handleMouseMove);
      tabContainer.removeEventListener("touchstart", handleTouchStart);
      tabContainer.removeEventListener("touchend", handleTouchEnd);
      tabContainer.removeEventListener("touchmove", handleTouchMove);
      tabContainer.removeEventListener("scroll", updateScrollIndicators);
      tabContainer.removeEventListener("keydown", handleKeydown);
      window.removeEventListener("resize", updateScrollIndicators);
    };

    // Store cleanup function for potential use
    tabContainer.dataset.cleanupFunction = cleanup;
  };

  // Initialize tab slider
  initTabSlider();

  const initializeSwiper = (carousel) => {
    // Check if Swiper is already initialized
    if (carousel.classList.contains("swiper-initialized")) return;

    const columns = parseInt(carousel.dataset.columns) || 4;
    const rows = parseInt(carousel.dataset.rows) || 2;

    try {
      const swiper = new Swiper(carousel, {
        slidesPerView: columns,
        grid: {
          rows: rows,
          fill: "row"
        },
        spaceBetween: 30,
        pagination: {
          el: carousel.querySelector(".swiper-pagination"),
          clickable: true
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            grid: { rows: 1 }
          },
          768: {
            slidesPerView: Math.min(2, columns),
            grid: { rows: Math.min(2, rows) }
          },
          1024: {
            slidesPerView: columns,
            grid: { rows: rows }
          }
        }
      });

      carousel.classList.add("swiper-initialized");
      carousel.dataset.swiperInstance = swiper;
    } catch (error) {
      console.warn("Swiper initialization failed:", error);
    }
  };

  // Initialize first tab
  const firstSwiper = document.querySelector(
    ".rbt-course-area .tab-pane.active .swiper"
  );
  if (firstSwiper) initializeSwiper(firstSwiper);

  // On tab switch, initialize Swiper in the tab if not initialized yet
  const tabButtons = document.querySelectorAll(
    '.rbt-course-area [data-bs-toggle="tab"]'
  );
  tabButtons.forEach((button) => {
    button.addEventListener("shown.bs.tab", function () {
      const target = document.querySelector(
        this.getAttribute("data-bs-target")
      );
      if (target) {
        const carousel = target.querySelector(".swiper");
        if (carousel && !carousel.classList.contains("swiper-initialized")) {
          initializeSwiper(carousel);
        }
      }
    });
  });
});
